import { memo } from 'react'
import styled from 'styled-components'

import { PairStatsPanelBundlers } from './pair-stats-panel-bundlers'
import { PairStatsPanelDevHolding } from './pair-stats-panel-dev-holding'
import { PairStatsPanelHolders } from './pair-stats-panel-holders'
import { PairStatsPanelInsiders } from './pair-stats-panel-insiders'
import { PairStatsPanelSnipers } from './pair-stats-panel-snipers'
import { PairStatsPanelTop10Holders } from './pair-stats-panel-top-10-holders'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const PairStatsPanel: React.FC<Props> = memo(({ pair, className }) => (
  <Root className={className}>
    <TopRow>
      <PairStatsPanelHolders pair={pair} />
      <PairStatsPanelTop10Holders pair={pair} />
      <PairStatsPanelDevHolding pair={pair} />
    </TopRow>
    <BottomRow>
      <PairStatsPanelSnipers pair={pair} />
      <BottomSeparator />
      <PairStatsPanelInsiders pair={pair} />
      <BottomSeparator />
      <PairStatsPanelBundlers pair={pair} />
    </BottomRow>
  </Root>
))

const Root = styled.div`
  display: grid;
  border-radius: 12px;
  overflow: hidden;
  background: var(--background-2);
  padding: 1px;
`

const BottomRow = styled.div`
  height: 60px;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
`

const TopRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: 2px;
  padding: 2px;

  border-radius: 12px;
  background: var(--appearance-1);
`

const BottomSeparator = styled.div`
  background: var(--background-3);
  width: 1px;
  height: 44px;
`
